import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { Modal, Button, Form, Input, Select, message } from 'antd';
import cs from './index.module.scss';
import { useStore } from '@/models';
import huazhuan from '@/assets/img/asset/huazhuanModal.png';
import { formatAssetsPrecision } from '@/utils/utils';
import CoinDropdown from '@/components/coinDropdown';
import SelectArrowIcon from '@/components/icons/SelectArrowIcon';
import { BALANCETYPE } from '@/config/const';
import CloseFilledIcon from '@/components/icons/CloseFilledIcon';
import TransferHIcon from "@/components/icons/TransferHIcon";

const { Option } = Select;

interface Props {
  symbol?: string;
  // handleOk: () => void;
  // handleCancel?: () => void;
}
const TransferModal: React.FC<Props> = ({ symbol }) => {
  const { t } = useTranslation();
  const { accountAsset, coin } = useStore();
  const [currentCoin, setCurrentCoin] = useState('');
  const [amount, setAmount] = useState<string>('');
  const {
    setTransferModal,
    showTransferModal,
    spotBalance,
    otcBalance,
    tigerSpuerBalance,
    fetchSupportAccount,
    supportAccount,
    fetchSupportCoin,
    supportCoinList,
    fetchTransfer,
    fetchBalance,
    tigerBalanceProfitTransfer,
    copyBalanceProfitTransfer,
  } = accountAsset;
  const { coinsPrecisionList } = coin;

  const [valueFrom, setValueFrom] = useState(''); //
  const [valueTo, setValueTo] = useState(''); //
  useEffect(() => {
    if (supportAccount && supportAccount?.length > 0) {
      const fistItem = supportAccount[1];
      setValueFrom(fistItem);
      setValueTo(supportAccount.filter(i => i !== fistItem)[0]);
    }
  }, [supportAccount]);

  const findIntersection = (arr1, arr2) => {
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    const intersection = [...set1].filter(item => set2.has(item));
    return intersection.map(item => ({ coin: item }));
  };
  const supportCoinListFilter = useMemo(() => {
    if (supportCoinList && supportCoinList?.length > 0 && valueFrom && valueTo) {
      const arr1 = supportCoinList.find(item => item.userWalletType === valueFrom);
      const arr2 = supportCoinList.find(item => item.userWalletType === valueTo);
      const arr = findIntersection(arr1.coins, arr2.coins);
      setCurrentCoin(arr[0].coin);
      return arr;
    }
  }, [supportCoinList, valueFrom, valueTo]);

  useEffect(() => {
    fetchSupportCoin();
    fetchSupportAccount();
  }, []);
  useEffect(() => {
    if (showTransferModal) {
      fetchBalance({ type: BALANCETYPE });
      setAmount('');
    }
  }, [showTransferModal]);
  const fromList = useMemo(() => supportAccount.filter(item => item !== valueTo), [supportAccount, valueTo]);
  const toList = useMemo(() => supportAccount.filter(item => item !== valueFrom), [supportAccount, valueFrom]);

  const handleSelectTo = e => {
    setValueTo(e);
  };
  const handleSelectFrom = e => {
    setValueFrom(e);
  };
  const btnDisabled = useMemo(() => {
    if (amount && currentCoin && valueFrom && valueTo) {
      return true;
    }
    false;
  }, [amount, currentCoin, valueFrom, valueTo]);
  const handleOk = () => {
    if (btnDisabled) {
      const data = {
        amount,
        coin: currentCoin,
        fromWalletType: valueFrom.toLowerCase(),
        toWalletType: valueTo.toLowerCase(),
      };
      fetchTransfer(data);
    }
  };

  const handleCancel = () => {
    setAmount('');
    // setValueFrom('');
    // setValueTo('');
    setCurrentCoin('');
    setTransferModal(false);
  };

  const balance = useMemo(() => {
    if (!showTransferModal) return 0;
    const balanceMap: Record<string, any[]> = {
      OTC: otcBalance,
      SPOT: spotBalance,
      CONTRACT: tigerBalanceProfitTransfer,
      SUPER: tigerSpuerBalance,
      COPY: copyBalanceProfitTransfer,
    };
    const balanceList = balanceMap[valueFrom] || [];
    const res = balanceList.find(item => item.coin.toUpperCase() === currentCoin.toUpperCase());
    if (!res) return 0;
    const useRealTime = valueFrom === 'CONTRACT' || valueFrom === 'COPY';
    const val = useRealTime ? res.availableBalanceProfit : res.availableBalance;
    return formatAssetsPrecision(val, coinsPrecisionList[currentCoin]);
  }, [
    currentCoin,
    spotBalance,
    valueFrom,
    coinsPrecisionList,
    otcBalance,
    tigerBalanceProfitTransfer,
    copyBalanceProfitTransfer,
    tigerSpuerBalance,
    showTransferModal,
  ]);
  const suffixAll = (
    <div className={cx(cs.all)} onClick={() => setAmount(String(balance))}>
      <span> {currentCoin}</span>
      <span className={cx('text-primary', 'pointer')}>{t('btn.all')}</span>
    </div>
  );
  const handleDrection = () => {
    setValueFrom(valueTo);
    setValueTo(valueFrom);
  };
  const handleSelect = v => {
    setCurrentCoin(v);
  };

  return (
    <Modal
      footer={null}
      title={t('common.transfer')}
      open={showTransferModal}
      onOk={handleOk}
      onCancel={handleCancel}
      width="448px"
      keyboard={false}
      maskClosable={false}
      centered={true}
      closeIcon={<CloseFilledIcon />}
    >
      <div className={cx(cs.modal)}>
        <div className={cx(cs.form)}>
          <div className={cx(cs.toFrom)}>
            <div className={cx(cs.to)}>
              <span className={cx(cs.title)}> {t('transfer.from')}</span>

              <Select
                popupClassName="normalDropdown"
                placeholder={t('otc.publish.qxzzh')}
                style={{ width: '100%', height: '48px' }}
                optionLabelProp="label"
                className="selectBorder"
                dropdownMatchSelectWidth={false}
                // dropdownStyle={{ width: '160px', padding: '0 0 0 8px' }}
                onSelect={handleSelectFrom}
                suffixIcon={<SelectArrowIcon />}
                value={valueFrom}
              >
                {fromList?.map((_: any) => (
                  <Option value={_} key={_} label={t(_)} className="option">
                    {t(_)}
                  </Option>
                ))}
              </Select>
            </div>
            {/* <img src={huazhuan} alt="" className={cx(cs.huazhuan)} onClick={handleDrection} /> */}
            <TransferHIcon className={cx(cs.huazhuan)} onClick={handleDrection} />
            <div className={cx(cs.from)}>
              <span className={cx(cs.title)}> {t('transfer.to')}</span>
              <Select
                popupClassName="normalDropdown"
                placeholder={t('otc.publish.qxzzh')}
                style={{ width: '100%', height: '48px' }}
                optionLabelProp="label"
                className="selectBorder"
                dropdownMatchSelectWidth={false}
                // dropdownStyle={{ width: '160px', padding: '0 0 0 8px' }}
                onSelect={handleSelectTo}
                suffixIcon={<SelectArrowIcon />}
                value={valueTo}
              >
                {toList?.map((_: any) => (
                  <Option value={_} key={_} label={t(_)} className="option">
                    {t(_)}
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div className={cx(cs.selectCoin)}>
            <span className={cx(cs.title)}> {t('transfer.coin')}</span>
            <CoinDropdown handleSelect={handleSelect} coinList={supportCoinListFilter} isBorder={true} />
          </div>
          <div className={cx(cs.ipt)}>
            <span className={cx(cs.title)}>{t('common.amount')}</span>

            <Input
              className="iptBorderAddonAfter"
              placeholder={t('transfer.amount')}
              onChange={e => {
                const val = e.target.value;
                const precision = coinsPrecisionList[currentCoin?.toUpperCase()] || 4;
                const reg = new RegExp(`^\\d{0,10}(\\.\\d{0,${precision}})?$`);
                if (val === '' || reg.test(val)) {
                  setAmount(val);
                }
              }}
              addonAfter={suffixAll}
              value={amount}
              style={{ height: '44px' }}
            />
          </div>

          <div className={cx(cs.balance)}>
            {t('transfer.balance')}
            <span className={cx('text-primary')}> {balance} </span>
            {currentCoin}
          </div>
          <div className={cx(cs.tips)}>
            {t('transfer.tips')}
          </div>
          <div onClick={handleOk} className={cx(btnDisabled ? 'primaryBtn' : 'primaryBtnDisabled', cs.modal_btn)}>
            {t('transfer.comfirm')}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default observer(TransferModal);
